import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { toast } from "sonner";
import { Badge, INTERVIEW_STATUS, fmtDateTime } from "./recruitLabels";

const FILTERS = [["scheduled", "À venir"], ["done", "Réalisés"], ["cancelled", "Annulés"]];

export const InterviewsTab = ({ catalog, onOpenCandidate, refreshKey }) => {
  const [status, setStatus] = useState("scheduled");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/recrutement/interviews", { params: { status, days: 90 } }).then((r) => setItems(r.data.items)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, [status, refreshKey]);

  return (
    <div className="bg-white border border-[#DEE2E6]" data-testid="interviews-tab">
      <header className="p-4 border-b border-[#DEE2E6] flex flex-wrap gap-1.5">
        {FILTERS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setStatus(k)} data-testid={`itw-filter-${k}`}
                  className={`text-[10px] uppercase tracking-wider font-bold px-2.5 py-1.5 border transition ${status === k ? "bg-[#7C3AED] text-white border-[#7C3AED]" : "bg-white border-[#DEE2E6] hover:border-[#7C3AED]"}`}>{l}</button>
        ))}
      </header>
      {items.length === 0 ? <div className="p-10 text-center text-sm text-[#868E96]" data-testid="itw-empty">Aucun entretien dans cette vue.</div> : (
        <div className="divide-y divide-[#DEE2E6]">
          {items.map((i) => (
            <button key={i.id} type="button" onClick={() => onOpenCandidate(i.candidate_id)} className="w-full text-left px-4 py-3 hover:bg-[#F8F9FA] flex flex-wrap items-center gap-3" data-testid={`itw-row-${i.id}`}>
              <span className="text-xs font-mono text-[#495057] w-40">{fmtDateTime(i.scheduled_at)}</span>
              <span className="text-sm font-semibold">{i.candidate_name}</span>
              <span className="text-xs text-[#495057] flex-1 truncate">{i.offer_title} · {catalog?.interview_modes?.[i.mode] || i.mode} · {i.duration_min} min</span>
              {i.interviewers?.length > 0 && <span className="text-[10px] text-[#868E96]">{i.interviewers.join(", ")}</span>}
              {i.evaluation && <span className="text-[10px] font-bold text-[#F59E0B]">★ {i.evaluation.average}</span>}
              <Badge cfg={INTERVIEW_STATUS[i.status]} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
